<template>
  <div>
    <nav class="sidebar global-nav">
      <f-menu :nav-items="navItems" :is-child="false" />
    </nav>
    <div class="toggle-btn" :class="{open: isOpen}" @click="toggle"></div>
  </div>
</template>

<script>
import FMenu from '~/components/frontend/Menu';

export default {
  name: 'f-sidebar',
  components: {FMenu},
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    },
    isOpen: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    toggle() {
      this.$emit('toggle');
      this.$nuxt.$emit('updateSizeCalendar');
    },
  }
}
</script>
